/* Landing perrito — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'perrito'). */


/* Contrato Shopify (literales para el publicador): __perrito_SEL perritoTriggerCOD te_regalo */
var PRICES={1:129900,2:219900,3:299900};
var OLD={1:169900,2:339800,3:509700};
var SLIDES=[__A('ad-assets/nuevo-hero.jpg'),'ad-assets/atf-puppywalk.mp4',__A('ad-assets/nuevo-pomerania-husky.jpg'),__A('ad-assets/nuevo-cachorro-poodle.jpg'),__A('ad-assets/nuevo-guia-husky.jpg'),__A('ad-assets/nuevo-husky.jpg'),__A('ad-assets/nuevo-infografia.jpg'),__A('ad-assets/real-husky-sonrisa.jpg'),__A('ad-assets/real-cachorros-caja.jpg'),__A('ad-assets/real-husky-caja.jpg'),__A('ad-assets/real-dos-perritos.jpg'),__A('ad-assets/real-husky-mango.jpg')];
/* Testimonios reales: se llenan cuando Santi los envíe. Vacío = no se muestra nada. */
var TESTI=[{"t": "Se lo regalé a mi hija y quedó fascinada. ¡No para de pasear a su perrito por toda la casa!", "n": "Mariana Rodríguez", "c": "Bogotá", "img": __A('ad-assets/cliente-4.jpg')}, {"t": "¡Este es un juguete tan lindo! A mi hijo de 2 años le encanta. Es adorable verlos jugar con él. Caminar, ladrar y mover la cola lo hacen aún más divertido. ¡Definitivamente un gran regalo para los niños pequeños!", "n": "Sandra M.", "c": ""}, {"t": "¡¡¡Este fue un 15 de 10!!! Se lo regalé a una sobrina de dos años. Juguete perfecto que funcionó tal como decía. Cuando aprietas la manija de la correa, el perro ladra mientras camina. Un mes después de llegar a casa, ¡sigue siendo su juguete favorito!", "n": "Juana D.", "c": ""}, {"t": "Es demasiado bonito y divertido. A mi pequeño le encanta verlo caminar y escuchar sus ladridos.", "n": "Andrés Martínez", "c": "Medellín"}, {"t": "Fue el regalo de cumpleaños perfecto. ¡La emoción de mi niña al verlo caminar no tuvo precio!", "n": "Laura Gómez", "c": "Cali"}, {"t": "La correa es genial porque mi hijo juega a sacarlo de paseo. ¡Se convirtió en su juguete favorito!", "n": "Camilo Torres", "c": "Barranquilla"}, {"t": "Es suave, hermoso y sus movimientos lo hacen muy especial. ¡Mi hija lo adora!", "n": "Daniela Ramírez", "c": "Bucaramanga"}, {"t": "Me sorprendió lo entretenido que es. Mi niño disfruta acariciándolo y jugando con él.", "n": "Felipe Herrera", "c": "Cartagena"}, {"t": "Es un regalo precioso. ¡Parece que tuviera su propia mascotica en casa!", "n": "Valentina Castro", "c": "Pereira"}, {"t": "A mi sobrina le encantó. Lo que más disfruta es verlo caminar y mover su colita.", "n": "Sebastián López", "c": "Villavicencio"}]; /* reseñas de compradores de este producto (aportadas por el proveedor); sin etiqueta de compra verificada */
var WA='573505802167';
var st={qty:2};
function $(s){return document.querySelector(s)}
function fmt(n){return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.')}
function V(p){return window.__A?window.__A(p):p}
function isVid(u){return /\.mp4$/.test(u)}
function buildGallery(){
 $('#track').innerHTML=SLIDES.map(function(u,i){return '<div class="slide">'+(isVid(u)?'<video src="'+V(u)+'" autoplay muted loop playsinline preload="metadata" aria-label="PuppyWalk caminando con su correa"></video>':'<img src="'+u+'" alt="PuppyWalk '+(i+1)+'"'+(i?' loading="lazy"':'')+'>')+'</div>'}).join('');
 $('#thumbs').innerHTML=SLIDES.map(function(u,i){return '<button type="button" class="thumb'+(i?'':' on')+'" data-i="'+i+'">'+(isVid(u)?'<video src="'+V(u)+'" muted playsinline preload="metadata"></video>':'<img src="'+u+'" alt="">')+'</button>'}).join('');
 $('#dots').innerHTML=SLIDES.map(function(u,i){return '<i class="'+(i?'':'on')+'"></i>'}).join('');
}
function go(i){var t=$('#track');t.scrollTo({left:i*t.clientWidth,behavior:'smooth'})}
function mark(i){document.querySelectorAll('#thumbs .thumb').forEach(function(e,k){e.classList.toggle('on',k===i)});document.querySelectorAll('#dots i').forEach(function(e,k){e.classList.toggle('on',k===i)})}
function render(){
 var rows=[
  {q:1,t:'1 perrito',s:'Ahorras '+fmt(OLD[1]-PRICES[1])+' · para tu hijo o para regalar',tag:''},
  {q:2,t:'2 perritos · uno para cada hermano',s:'Ahorras '+fmt(OLD[2]-PRICES[2])+' · ≈'+fmt(Math.round(PRICES[2]/2/100)*100)+' c/u',tag:''},
  {q:3,t:'3 perritos · para toda la familia',s:'Ahorras '+fmt(OLD[3]-PRICES[3])+' · ≈'+fmt(Math.round(PRICES[3]/3/100)*100)+' c/u',tag:'MAYOR AHORRO'}];
 $('#bundles').innerHTML=rows.map(function(r){return '<button type="button" class="bundle'+(r.q===st.qty?' on':'')+'" data-qty="'+r.q+'">'+(r.tag?'<span class="tag">'+r.tag+'</span>':'')+'<span class="radio"></span><span class="t">'+r.t+'<small>'+r.s+'</small></span><span class="p"><s>'+fmt(OLD[r.q])+'</s>'+fmt(PRICES[r.q])+'</span></button>'}).join('');
 $('#sName').textContent='PuppyWalk · '+st.qty+' u';
 $('#sPrice').textContent=fmt(PRICES[st.qty]);
}
function renderTesti(){
 if(!TESTI.length)return;
 var t=TESTI[0];
 $('#heroTesti').innerHTML='<div class="testi'+(t.img?' ph':'')+'">'+(t.img?'<img src="'+V(t.img)+'" alt="Foto de un cliente con su PuppyWalk">':'')+'<div><span style="color:#FFB400;letter-spacing:2px">★★★★★</span><br>“'+t.t+'”<b>'+t.n+(t.c?' · '+t.c:'')+' · reseña de un comprador de este perrito</b></div></div>';
 $('#testiSec').innerHTML='<section class="alt"><div class="wrap"><h2>Lo que dicen quienes <em>ya lo tienen</em></h2><div class="feats" style="margin-top:16px">'+TESTI.map(function(x){return '<div class="feat"><div class="ic">⭐</div><div><b>'+x.n+(x.c?' · '+x.c:'')+'</b><span>“'+x.t+'”</span></div></div>'}).join('')+'</div></div></section>';
}
document.addEventListener('click',function(e){
 var t;
 if((t=e.target.closest('.bundle'))){st.qty=+t.dataset.qty;render();}   /* el combo solo selecciona */
 else if((t=e.target.closest('.thumb'))){go(+t.dataset.i);mark(+t.dataset.i)}
});
$('#track').addEventListener('scroll',function(){var t=this;mark(Math.round(t.scrollLeft/t.clientWidth))},{passive:true});

/* ===== Releasit: abrir con el combo elegido preseleccionado ===== */
function waitFor(fn,max,step,cb){var t=Date.now();(function tick(){var v=fn();if(v)return cb(v);if(Date.now()-t>max)return cb(null);setTimeout(tick,step||50)})()}
function pickOffer(qty){
 waitFor(function(){var d=document.querySelector('dialog[open]');return d&&d.querySelector('input[name="quantity_offer"][value="quantity_'+(qty-1)+'"]')},20000,50,function(r){
  if(!r)return;
  if(!r.checked)r.click();
 })
}
/* punto de compra único (Contrato Shopify) */
window.openOrder=function(){
 var on=document.querySelector('.bundle.on'); var qty=on?+on.dataset.qty:1;
 window.__perrito_SEL={qty:qty};
 try{localStorage.setItem('te_regalo','perrito|'+Date.now())}catch(e){}
 if(window.perritoTriggerCOD&&window.perritoTriggerCOD()!==false){pickOffer(qty);return}
 var txt='PuppyWalk · '+qty+(qty===1?' unidad':' unidades')+' · '+fmt(PRICES[qty])+' (pago al recibir)';
 $('#modalTxt').textContent=txt;
 $('#modalWa').href='https://wa.me/'+WA+'?text='+encodeURIComponent('Hola, quiero pedir: '+txt);
 $('#modal').classList.add('on');
};
/* sticky tras el primer scroll */
var sticky=$('#sticky');
function onScroll(){sticky.classList.toggle('show',window.scrollY>window.innerHeight*0.6)}
window.addEventListener('scroll',onScroll,{passive:true});
/* cuenta regresiva real a Navidad (24-dic) */
function xmasDays(){var n=new Date(),y=n.getFullYear(),x=new Date(y,11,24);if(n>x)x=new Date(y+1,11,24);return Math.max(0,Math.ceil((x-n)/86400000))}
document.querySelectorAll('.xd').forEach(function(e){e.textContent=xmasDays()});
buildGallery();render();renderTesti();onScroll();
/* videos: autoplay solo en pantalla */
(function(){document.querySelectorAll('video[data-v]').forEach(function(v){v.src=V(v.getAttribute('src'))});var vs=document.querySelectorAll('video');if(!('IntersectionObserver' in window))return;var o=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){})}else v.pause()})},{threshold:.25});vs.forEach(function(v){o.observe(v)})})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__perrito_SEL || {};
    var V = window.PERRITO_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__perrito-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  /* ¿Está abierto el modal de Releasit? (<dialog class="rsi-form-wrap"> con open) */
  function rsiOpen() {
    var d = document.querySelectorAll('dialog');
    for (var i = 0; i < d.length; i++) { if (d[i].open && /rsi/.test(String(d[i].className))) return true; }
    return false;
  }

  /* UN solo click debe abrir el formulario. Si el cliente toca antes de que Releasit termine de
     cargar (botón aún sin enganchar), el primer click se perdía y hacían falta dos: ahora se
     reintenta hasta confirmar que el modal abrió (máx. ~15 s). */
  window.perritoTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    if (window.perrito_opening) clearInterval(window.perrito_opening);
    var tries = 0;
    function attempt() {
      sync();
      var b = findReleasitButton();
      if (b) b.click();
      else if (tries > 8 && window._rsiV2 && typeof window._rsiV2.setState === 'function') {
        try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
      }
    }
    setTimeout(function () {
      attempt();
      window.perrito_opening = setInterval(function () {
        tries++;
        if (rsiOpen() || tries > 50) { clearInterval(window.perrito_opening); return; }
        attempt();
      }, 300);
    }, 50);
  };
})();
